module.exports = __webpack_public_path__ + "static/media/iconPending.95463fa0.svg";